@use "../../../globals/settings";
@use "../../../globals/bcp";
@use "../../../globals/bcp-2022/objects/links";
@use "../../../globals/bcp-2022/objects/lists";
@use "../../../globals/libs/hy.core.css/layout/page-row";

$self: ".a-search-suggestions";

:host {
  display: block;
  position: relative;

  @include bcp.z-index("search", 1);
}

.a-search-suggestions-wrapper {
  background: bcp.colorVar("bg");
  box-shadow: settings.$box-shadow;
  position: absolute;
  left: 0;
  right: 0;
  margin-top: bcp.n(-2);
  padding-bottom: bcp.n(4);
  box-sizing: border-box;

  &::after {
    content: "";
    display: block;
    position: absolute;
    top: (settings.$box-shadow-height * -1) + 1;
    left: 0;
    right: 0;
    height: settings.$box-shadow-height;
    background: bcp.colorVar("bg");
  }

  @include bcp.respond-lte(tabletp) {
    margin-top: 10px;
  }
}

.a-search-suggestions {
  @include lists.transparent;

  &__item {
    display: block;

    &--with-separator {
      border-bottom: 1px solid bcp.colorVar("separator");
    }
  }

  &__result-link {
    @include links.inline;
    display: grid;
    grid-template-columns: 50% 50%;
    grid-template-areas:
      "name price"
      "sku . ";
    padding-top: bcp.n(1);
    padding-bottom: bcp.n(1);

    @include bcp.set-css-var(link, color, settings.$text-color);
    @include bcp.set-css-var(link, text-decoration, none);

    &:hover {
      background: bcp.colorVar("bg-secondary");
      color: bcp.cssVar(link, color);
      text-decoration: bcp.cssVar(link, text-decoration);
    }

    @include bcp.respond-gt(mobile) {
      grid-template-columns: 75% 25%;
      grid-template-areas:
        "name price"
        "sku . ";
      padding: bcp.n(1);
    }
  }

  &__item-name {
    @include bcp.text-overflow(2);
    grid-area: name;
    display: -webkit-box;

    &--family {
      font-weight: bcp.$font-weight-bold;
    }
  }

  &__item-sku {
    @include bcp.text-s;
    grid-area: sku;
  }

  &__item-price {
    grid-area: price;
    justify-self: right;
    font-weight: bcp.$font-weight-bold;
  }

  &__results-link {
    padding-top: bcp.n(4);
  }
}

.l-page-row {
  @include page-row.page-row;
}

// ------------------- CUSTOM -----------------------------------------------------------------------------------------
// ...
